import encode from "./encoder";
import Barcode from "../Barcode.js";
class UPC extends Barcode {
  constructor(data, options) {
    if (data.search(/^[0-9]{11}$/) !== -1) {
      data += checksum(data);
    }
    super(data, options);
    this.displayValue = options.displayValue;
    if (options.fontSize > options.width * 10) {
      this.fontSize = options.width * 10;
    } else {
      this.fontSize = options.fontSize;
    }
    this.guardHeight = options.height + this.fontSize / 2 + options.textMargin;
  }
  valid() {
    return this.data.search(/^[0-9]{12}$/) !== -1 && this.data[11] == checksum(this.data);
  }
  encode() {
    if (this.options.flat) {
      return this.flatEncoding();
    } else {
      return this.guardedEncoding();
    }
  }
  flatEncoding() {
    var result = "";
    result += "101";
    result += encode(this.data.substr(0, 6), "LLLLLL");
    result += "01010";
    result += encode(this.data.substr(6, 6), "RRRRRR");
    result += "101";
    return {
      data: result,
      text: this.text
    };
  }
  guardedEncoding() {
    var result = [];
    if (this.displayValue) {
      result.push({
        data: "00000000",
        text: this.text.substr(0, 1),
        options: { textAlign: "left", fontSize: this.fontSize }
      });
    }
    result.push({
      data: "101" + encode(this.data[0], "L"),
      options: { height: this.guardHeight }
    });
    result.push({
      data: encode(this.data.substr(1, 5), "LLLLL"),
      text: this.text.substr(1, 5),
      options: { fontSize: this.fontSize }
    });
    result.push({
      data: "01010",
      options: { height: this.guardHeight }
    });
    result.push({
      data: encode(this.data.substr(6, 5), "RRRRR"),
      text: this.text.substr(6, 5),
      options: { fontSize: this.fontSize }
    });
    result.push({
      data: encode(this.data[11], "R") + "101",
      options: { height: this.guardHeight }
    });
    if (this.displayValue) {
      result.push({
        data: "00000000",
        text: this.text.substr(11, 1),
        options: { textAlign: "right", fontSize: this.fontSize }
      });
    }
    return result;
  }
}
function checksum(number) {
  var result = 0;
  var i;
  for (i = 1; i < 11; i += 2) {
    result += parseInt(number[i]);
  }
  for (i = 0; i < 11; i += 2) {
    result += parseInt(number[i]) * 3;
  }
  return (10 - result % 10) % 10;
}
var stdin_default = UPC;
export {
  checksum,
  stdin_default as default
};
